module.exports = __webpack_public_path__ + "bedroom-quilt2.62dc3cac.png";